import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";
import { PathPickMembershipApplyRequestBody } from "@/features/pathpick/features/membership/types/request-body";

const url = {
  applyPathPickMembership: (companyId: number) =>
    `/buyers/${companyId}/pathpick/membership-applications`,
};

export const pathPickMembershipMutationApi = {
  // 패스픽 멤버십 신청 — 어드민이 입금을 확인해야 플랜이 실제로 배정된다.
  // 성공 응답 스키마가 비어 있어 반환값은 쓰지 않는다.
  applyPathPickMembership: async (
    companyId: number,
    body: PathPickMembershipApplyRequestBody
  ) =>
    await axiosClient.post(
      url.applyPathPickMembership(companyId),
      toSnakeKeyObject(body)
    ),
};
